import React, { MouseEventHandler, ReactNode } from 'react';
import { IoChevronForwardSharp as MoveForwardIcon } from 'react-icons/io5';
import cn from 'classnames';

type Props = {
  icon: ReactNode;
  title: ReactNode;
  value?: ReactNode;
  completed?: boolean;
  isActive?: boolean;
  onClick: MouseEventHandler<HTMLLIElement>;
  disabled?: boolean;
};

export const BookingStepItem = ({
  value,
  title,
  icon,
  isActive,
  completed,
  disabled,
  onClick,
}: Props) => {
  return (
    <li
      onClick={disabled ? undefined : onClick}
      className={cn(
        'group relative h-10 overflow-hidden w-full  flex items-center',
        completed && !disabled ? 'bg-primary-default text-primary-contrast' : '',
        { 'opacity-30': disabled }
      )}
    >
      <div
        className={cn(
          'absolute h-full w-full z-10  flex  flex-row items-center ',
          {
            'text-white ': isActive,
          },
          { 'justify-evenly': !isActive && !completed }
        )}
      >
        <div className="flex flex-1 gap-x-2 justify-center items-center">
          {!value && icon}
          <span className="text-sm">{value || title}</span>
        </div>
        {!isActive && !completed && <MoveForwardIcon className="text-xl" />}
      </div>
      <div
        className={cn(
          'h-10 flex-1  group-first-of-type:rounded-tl-md group-first-of-type:rounded-bl-md',
          {
            'bg-primary-default': isActive,
          }
        )}
      ></div>
      <div className="w-[23px]">
        {isActive && (
          <div className="w-[33px] relative right-4 h-[33px] bg-primary-default transform rotate-45 rounded-md"></div>
        )}
        {completed && !disabled && (
          <div className={'group-last-of-type:hidden w-full text-right'}>|</div>
        )}
      </div>
    </li>
  );
};
